// Lightweight client-side pre-check for instant UX feedback.
// This is NOT the source of truth — the database trigger
// (migrations/008_block_disposable_emails.sql) is the real, unbypassable guard.
// Keep this list short; it only needs to catch the most common offenders fast.
const DISPOSABLE_DOMAINS = new Set([
  "mailinator.com",
  "10minutemail.com",
  "guerrillamail.com",
  "guerrillamail.info",
  "sharklasers.com",
  "temp-mail.org",
  "tempmail.com",
  "tempmailo.com",
  "throwawaymail.com",
  "yopmail.com",
  "getnada.com",
  "dispostable.com",
  "trashmail.com",
  "maildrop.cc",
  "fakeinbox.com",
  "mintemail.com",
  "mohmal.com",
  "emailondeck.com",
  "moakt.com",
  "tempr.email",
]);

export function getEmailDomain(email) {
  return String(email || "").trim().toLowerCase().split("@")[1] || "";
}

export function isDisposableEmail(email) {
  return DISPOSABLE_DOMAINS.has(getEmailDomain(email));
}
